module.exports = __webpack_public_path__ + "paprica.svg?9098206e1b46aeec36f8eb48d1e05a82";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paprica.svg
// module id = 855
// module chunks = 0